/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChangeRequestOpeningDay } from './ChangeRequestOpeningDay';
import {
    ChangeRequestOpeningDayFromJSON,
    ChangeRequestOpeningDayFromJSONTyped,
    ChangeRequestOpeningDayToJSON,
    ChangeRequestOpeningDayToJSONTyped,
} from './ChangeRequestOpeningDay';

/**
 * 
 * @export
 * @interface ChangeRequestOpeningHourRequest
 */
export interface ChangeRequestOpeningHourRequest {
    /**
     * 
     * @type {ChangeRequestOpeningDay}
     * @memberof ChangeRequestOpeningHourRequest
     */
    monday?: ChangeRequestOpeningDay;
    /**
     * 
     * @type {ChangeRequestOpeningDay}
     * @memberof ChangeRequestOpeningHourRequest
     */
    tuesday?: ChangeRequestOpeningDay;
    /**
     * 
     * @type {ChangeRequestOpeningDay}
     * @memberof ChangeRequestOpeningHourRequest
     */
    wednesday?: ChangeRequestOpeningDay;
    /**
     * 
     * @type {ChangeRequestOpeningDay}
     * @memberof ChangeRequestOpeningHourRequest
     */
    thursday?: ChangeRequestOpeningDay;
    /**
     * 
     * @type {ChangeRequestOpeningDay}
     * @memberof ChangeRequestOpeningHourRequest
     */
    friday?: ChangeRequestOpeningDay;
    /**
     * 
     * @type {ChangeRequestOpeningDay}
     * @memberof ChangeRequestOpeningHourRequest
     */
    saturday?: ChangeRequestOpeningDay;
    /**
     * 
     * @type {ChangeRequestOpeningDay}
     * @memberof ChangeRequestOpeningHourRequest
     */
    sunday?: ChangeRequestOpeningDay;
}

/**
 * Check if a given object implements the ChangeRequestOpeningHourRequest interface.
 */
export function instanceOfChangeRequestOpeningHourRequest(value: object): value is ChangeRequestOpeningHourRequest {
    return true;
}

export function ChangeRequestOpeningHourRequestFromJSON(json: any): ChangeRequestOpeningHourRequest {
    return ChangeRequestOpeningHourRequestFromJSONTyped(json, false);
}

export function ChangeRequestOpeningHourRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangeRequestOpeningHourRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'monday': json['monday'] == null ? undefined : ChangeRequestOpeningDayFromJSON(json['monday']),
        'tuesday': json['tuesday'] == null ? undefined : ChangeRequestOpeningDayFromJSON(json['tuesday']),
        'wednesday': json['wednesday'] == null ? undefined : ChangeRequestOpeningDayFromJSON(json['wednesday']),
        'thursday': json['thursday'] == null ? undefined : ChangeRequestOpeningDayFromJSON(json['thursday']),
        'friday': json['friday'] == null ? undefined : ChangeRequestOpeningDayFromJSON(json['friday']),
        'saturday': json['saturday'] == null ? undefined : ChangeRequestOpeningDayFromJSON(json['saturday']),
        'sunday': json['sunday'] == null ? undefined : ChangeRequestOpeningDayFromJSON(json['sunday']),
    };
}

export function ChangeRequestOpeningHourRequestToJSON(json: any): ChangeRequestOpeningHourRequest {
    return ChangeRequestOpeningHourRequestToJSONTyped(json, false);
}

export function ChangeRequestOpeningHourRequestToJSONTyped(value?: ChangeRequestOpeningHourRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'monday': ChangeRequestOpeningDayToJSON(value['monday']),
        'tuesday': ChangeRequestOpeningDayToJSON(value['tuesday']),
        'wednesday': ChangeRequestOpeningDayToJSON(value['wednesday']),
        'thursday': ChangeRequestOpeningDayToJSON(value['thursday']),
        'friday': ChangeRequestOpeningDayToJSON(value['friday']),
        'saturday': ChangeRequestOpeningDayToJSON(value['saturday']),
        'sunday': ChangeRequestOpeningDayToJSON(value['sunday']),
    };
}

